import {
  BillingInterval,
  CountryCode,
  LocalizedString,
  Maybe,
  OrderLine,
  SalesOrderStatus,
} from 'types/generatedSchemaTypes';
import { create } from 'zustand';

// Keep the Subscription type for other files that use it
export type Subscription = {
  uid?: string;
  billingInterval?: BillingInterval;
  validFrom?: Date;
  name?: string;
  description?: LocalizedString;
  countryCode?: CountryCode;
  prices?: any;
  renewal?: boolean | null;
  creditCardId?: string | null;
  status?: SalesOrderStatus;
  nextBillingDate?: Date | null;
  orderLines?: Maybe<OrderLine>[];
  orderLineIdWithVersion?: string;
  isFirstMonthFree?: boolean;
  endDate?: string | null;
};

type SubscriptionData = {
  isRecurring: boolean;
  nextBillingDate: Date | null;
};

type SubscriptionStoreActions = {
  setIsRecurring: (isRecurring: boolean) => void;
  setNextBillingDate: (date: Date | null) => void;
};

export const useSubscriptionStore = create<
  SubscriptionData & SubscriptionStoreActions
>((set) => ({
  isRecurring: false,
  nextBillingDate: null,
  setIsRecurring: (isRecurring) => set({ isRecurring }),
  setNextBillingDate: (nextBillingDate) => set({ nextBillingDate }),
}));
